import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { PublicUser } from "@/app/types/PublicUser";

export type UserState = {
  user: PublicUser | null;
  setUser: (user: PublicUser) => void;
};

export const UserStore = create<UserState>()(
  devtools((set) => ({
    user: null,
    setUser: (user) => set({ user }),
  })),
);
